import { API_URL, obterToken } from './apiClient';

/* converte um PDF pro padrão PDF/A — processado no nosso próprio backend
   (nunca em site de terceiro), o arquivo não fica guardado depois */
export async function converterParaPdfA(arquivo) {
  const token = obterToken();

  const form = new FormData();
  form.append('arquivo', arquivo);

  const response = await fetch(`${API_URL}/pdf/converter`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });

  if (!response.ok) {
    let mensagem = 'Erro ao converter o PDF';
    try { mensagem = (await response.json()).error || mensagem; } catch {}
    throw new Error(mensagem);
  }

  return response.arrayBuffer();
}
